'use strict';
import angular from 'angular';

angular.module('app.services')
    .factory('RuleService', function(RuleFactory, $q) {
        var service = {};
        service.ruleSet = null;

        // Get a single rule set
        service.getRuleSet = function(ruleSetId) {
            var deferred = $q.defer();
            var params = {
                'id': ruleSetId
            };

            RuleFactory.ruleSet().get(params).$promise.then(function(data) {
                service.ruleSet = data.ruleSet;
                deferred.resolve();
            }, function() {
                console.log("error getting rule set " + ruleSetId);
                deferred.reject();
            });

            return deferred.promise;
        };

        return service;
    })

    .factory('RuleFactory', ['$resource', 'AppConfig', function($resource, AppConfig) {
            var factory = {};

            factory.ruleSet = function() {
                return $resource(AppConfig.IO_API_URL + 'rules/ruleSet', null, {
                    'get': {
                        method: 'GET',
                        isArray: false
                    }
                });
            };

            return factory;
    }])

    .factory('TapIoRuleSetService', function(TapIoRuleSetFactory, $q) {
        var service = {};
        service.ruleSets = null;
        service.rulesList = null;
        service.ruleOperationList = null;

        service.getRuleSets = function() {
            var deferred = $q.defer();

            TapIoRuleSetFactory.ruleSet().get({
                'ruleSets': 'ruleSets'
            }).$promise.then(function(data) {
                service.ruleSets = data.ruleSets;
                deferred.resolve();
            }, function() {
                console.log("error loading tapIO ruleSets list");
                deferred.reject();
            });

            return deferred.promise;
        };

        service.addRuleSet = function(param) {
            var deferred = $q.defer();

            TapIoRuleSetFactory.ruleSet().save({
                'ruleSets': 'ruleSet'
            }, param).$promise.then(function(data) {
                deferred.resolve(data.ruleSet);
            }, function() {
                console.log("error saving tapIO rule Set");
                deferred.reject();
            });

            return deferred.promise;
        };

        service.updateRuleSet = function(param) {
            var deferred = $q.defer();

            TapIoRuleSetFactory.ruleSet().update({
                'ruleSets': 'ruleSet'
            }, param).$promise.then(function(data) {
                deferred.resolve(data.ruleSet);
            }, function() {
                console.log("error saving tapIO rule Set");
                deferred.reject();
            });

            return deferred.promise;
        };

        service.getRulesList = function(ruleSetId) {
            var deferred = $q.defer();

            TapIoRuleSetFactory.ruleSet().get({
                'ruleSetId': ruleSetId
            }).$promise.then(function(data) {
                service.rulesList = data.rules;
                deferred.resolve();
            }, function() {
                console.log("error loading tapIO rule list for ruleSet Id: " + ruleSetId);
                deferred.reject();
            });

            return deferred.promise;
        };

        service.addRule = function(param) {
            var deferred = $q.defer();

            TapIoRuleSetFactory.ruleSet().save({
                'ruleSets': 'rule'
            }, param).$promise.then(function(data) {
                deferred.resolve(data.rule);
            }, function() {
                console.log("error saving tapIO rule Set");
                deferred.reject();
            });

            return deferred.promise;
        };

        service.updateRule = function(param) {
            var deferred = $q.defer();

            TapIoRuleSetFactory.ruleSet().update({
                'ruleSets': 'rule'
            }, param).$promise.then(function(data) {
                deferred.resolve(data.rule);
            }, function() {
                console.log("error saving tapIO rule Set");
                deferred.reject();
            });

            return deferred.promise;
        };

        service.deleteRule = function(ruleId) {
            var deferred = $q.defer();

            TapIoRuleSetFactory.ruleSet().delete({
                'ruleSets': 'rule',
                'id': ruleId
            }).$promise.then(function(data) {
                deferred.resolve(data);
            }, function() {
                console.log("error deleting tapIO rule");
                deferred.reject();
            });

            return deferred.promise;
        };

        service.deleteRuleSet = function(ruleSetId) {
            var deferred = $q.defer();

            TapIoRuleSetFactory.ruleSet().delete({
                'ruleSets': 'ruleSet',
                'id': ruleSetId
            }).$promise.then(function(data) {
                deferred.resolve(data);
            }, function() {
                console.log("error deleting tapIO rule set");
                deferred.reject();
            });

            return deferred.promise;
        };

        service.getRuleOperations = function() {
            var deferred = $q.defer();

            TapIoRuleSetFactory.ruleOperations().get().$promise.then(function(data) {
                service.ruleOperationList = data.ruleOperations;
                deferred.resolve();
            }, function() {
                console.log("error loading tapIO rule operations list");
                deferred.reject();
            });

            return deferred.promise;
        };

        service.getRuleTargets = function () {
            var deferred = $q.defer();

            TapIoRuleSetFactory.ruleTargets().get().$promise.then(function (data) {
                service.ruleTargetsList = data.ruleTargets;
                deferred.resolve();
            }, function () {
                console.log("error loading tapIO rule targets");
                deferred.reject();
            });

            return deferred.promise;
        };

        return service;
    })

    .factory('TapIoRuleSetFactory', ['$resource', 'AppConfig', function($resource, AppConfig) {
        var factory = {};

        factory.ruleSet = function() {
            return $resource(AppConfig.IO_API_URL + 'rules/:ruleSets', {
                ruleSets: '@ruleSets'
            }, {
                'get': {
                    method: 'GET',
                    isArray: false
                },
                'save': {
                    method: 'POST'
                },
                'update': {
                    method: 'PUT'
                },
                'delete': {
                    method: 'DELETE'
                }
            });
        };

        factory.ruleOperations = function() {
            return $resource(AppConfig.IO_API_URL + 'rules/ruleOperations', {}, {
                'get': {
                    method: 'GET',
                    isArray: false
                },
                'save': {
                    method: 'POST'
                },
                'update': {
                    method: 'PUT'
                }
            });
        };

        factory.ruleTargets = function () {
            return $resource(AppConfig.IO_API_URL + 'rules/ruleTargets', {}, {
                'get': {
                    method: 'GET',
                    isArray: false
                }
            });
        };

        return factory;
    }]);
